import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {AccountSortField as AccountSortFields} from 'src/openapi/admin/models/AccountSortField';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultStateSlice = getCachedTableStateSlice<
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultState', AccountSortFields.ACCOUNT_NAME);

export const accountSearchResultStateActions = accountSearchResultStateSlice.actions;
export const accountSearchResultStateSelector:
CachedTableStateSelector<AccountSearchCriteria, AccountSortField, AccountSearchFiltering> =
    state => state.accountSearchResult.state;
